import clsx from 'clsx';
import React from 'react';
import * as yup from 'yup';
import { getFileUrl } from '../../../services/createNftService';
import { formatNumber } from '../../../services/utilsService';
import { formatNumericValues, parseLocalStrings } from '../../../utils/format';
import { captilizeFirstChar, formatIsoDate } from '../../../utils/mapper';
import { createValidation } from '../../../utils/validation';
import SelectField from '../../Common/Forms/Fields/SelectField';
import FileComponent from '../../Common/Forms/FilesComponents/FileComponent';
import TextAreaComponent from '../../Common/Forms/TextAreaComponent';
import ImgUpload from '../../Common/ImgUpload/ImgUpload';

export const dateTimePicker = ({ values, setValues, field }) => {
  const handleChange = ({ target: { value } }) =>
    setValues({ ...values, [field.name]: new Date(value).getTime() / 1000 });
  return (
    <>
      <input onChange={handleChange} type="datetime-local" />
    </>
  );
};

export const addProjectFields = () => [
  {
    name: 'token_name',
    id: 'token_name',
    className: 'w-50 fill-at-mobile',
    label: 'common.token_name',
  },
  {
    name: 'token_symbol',
    id: 'token_symbol',
    className: 'w-50 fill-at-mobile',
    label: 'common.token_symbol',
  },
  {
    name: 'description',
    id: 'description',
    className: 'w-100',
    label: 'hpool.description',
    renderField: ({ setValues, values, touched, errors, setTouched }) => (
      <>
        <TextAreaComponent
          errorClassName="field-error-text"
          inputClassName={clsx({ 'field-error': errors?.description?.[0] && touched?.description })}
          error={errors?.description?.[0]}
          showErrorText
          style={{ minHeight: '8rem' }}
          className={clsx('w-100')}
          meta={{ touched }}
          input={{
            onChange: ({ target: { value: newValue } }) => {
              setValues({ ...values, description: newValue });
            },
            value: values?.description || '',
            rows: '4',
            onBlur: () => setTouched({ ...touched, description: true }),
          }}
          maxLength={140}
          counter
        />
      </>
    ),
  },
  {
    name: 'token_icon',
    id: 'token_icon',
    className: 'w-50 m-0-auto fill-at-mobile my-5',
    label: 'hpool.token_img',
    renderField: ({ setValues, values }) => (
      <ImgUpload passedUrl={values?.token_icon} onUrlFound={(url) => setValues({ ...values, token_icon: url })} />
    ),
  },
  {
    name: 'border-1',
    id: 'border-1',
    className: 'w-100 border',
    label: '',
    render: () => <div />,
  },
  {
    name: 'website',
    id: 'website',
    className: 'w-50 fill-at-mobile',
    label: 'modal.website_link',
  },
  {
    name: 'twitter',
    id: 'twitter',
    className: 'w-50 fill-at-mobile',
    label: 'modal.twitter_link',
  },
  {
    name: 'telegram',
    id: 'telegram',
    className: 'w-50 fill-at-mobile',
    label: 'modal.telegram_link',
  },
  {
    name: 'discord',
    id: 'discord',
    className: 'w-50 fill-at-mobile',
    label: 'modal.discord_link',
  },
  {
    name: 'border-2',
    id: 'border-2',
    className: 'w-100 border',
    label: '',
    render: () => <div />,
  },
  // {
  //   name: 'allocation_in_usd',
  //   id: 'allocation_in_usd',
  //   dataType: 'currency',
  //   className: 'w-50 fill-at-mobile',
  //   label: 'modal.usd_allocation',
  //   tag: 'number',
  //   renderValue: formatNumericValues,
  // },
  {
    name: 'token_allocation',
    id: 'token_allocation',
    className: 'w-50 fill-at-mobile',
    label: 'modal.token_allocation',
    tag: 'number',
    renderValue: formatNumericValues,
  },
  {
    name: 'market_cap',
    id: 'market_cap',
    className: 'w-50 fill-at-mobile',
    label: 'modal.market_cap',
    tag: 'number',
    renderValue: formatNumericValues,
  },
  {
    name: 'our_price',
    id: 'our_price',
    className: 'w-50 fill-at-mobile',
    label: 'modal.our_price',
    tag: 'number',
    renderValue: formatNumericValues,
  },
  {
    name: 'public_price',
    id: 'public_price',
    className: 'w-50 fill-at-mobile',
    label: 'modal.public_price',
    tag: 'number',
    renderValue: formatNumericValues,
  },
  {
    name: 'end_of_cliff',
    id: 'end_of_cliff',
    className: 'w-50 fill-at-mobile',
    label: 'modal.end_of_cliff',
    renderField: dateTimePicker,
  },
  {
    name: 'end_of_vesting',
    id: 'end_of_vesting',
    className: 'w-50 fill-at-mobile',
    label: 'modal.end_of_vesting',
    type: 'datetime-local',
    renderField: dateTimePicker,
  },
  {
    name: 'lp_address',
    id: 'lp_address',
    className: 'w-50 fill-at-mobile',
    label: 'vpool.lp_address',
    infoHint: 'LP address must be linked to stablecoin',
  },
  // {
  //   name: 'status',
  //   id: 'status',
  //   className: 'w-50 fill-at-mobile',
  //   label: 'common.status',
  //   renderField: ({ values, setValues }) => (
  //     <>
  //       <SelectField
  //         placeholder={captilizeFirstChar(values?.status || 'Select Status')}
  //         onChange={(option) => setValues({ ...values, status: option.value })}
  //         options={[
  //           {
  //             value: 'live',
  //             label: 'Live',
  //           },
  //           {
  //             value: 'planned',
  //             label: 'Planned',
  //           },
  //         ]}
  //       />
  //     </>
  //   ),
  // },
];

export const addProjectFieldsValidationSchema = createValidation({
  token_name: yup.string().required('Please make sure to add a project name'),
  token_symbol: yup.string().required('Please make sure to add a project token'),
  description: yup.string().required('Please add a project description').max(140, 'max'),
  // token_icon: yup.object().shape({
  //   file: yup.mixed().required('File is required'),
  // }),
  website: yup.string().url().nullable(),
  twitter: yup.string().url().nullable(),
  telegram: yup.string().url().nullable(),
  discord: yup.string().url().nullable(),
  // allocation_in_usd: yup.string().nullable(),
  token_allocation: yup.string().nullable(),
  market_cap: yup.string().nullable(),
  our_price: yup.string().nullable(),
  public_price: yup.string().nullable(),
  end_of_cliff: yup.mixed().test('len', 'Invalid timestamp', (val) => `${val}`?.length === 10 || !+val || val === null), // allow zero value since it's the default from BE side
  end_of_vesting: yup
    .mixed()
    .test('len', 'Invalid timestamp', (val) => `${val}`?.length === 10 || !+val || val === null),
  lp_address: yup.string('').min(42, 'Invalid Token address').max(42, 'Invalid Token address').nullable(),
  // status: yup.string().nullable(),
});
